import { Theme, createStyles, WithStyles, withStyles } from "@material-ui/core/styles";
import * as React from "react";
import withRoot from "../../withRoot";
import Dialog from "@material-ui/core/Dialog";
import { Contact } from "../../services/ContactService";
import ContactSearch from "../../components/ContactSearch";
import Typography from "@material-ui/core/Typography";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import Grid from "@material-ui/core/Grid";


const styles = (theme: Theme) => (
    createStyles({
    }));

interface Props extends WithStyles<typeof styles> {
    open: boolean
    onClose: () => void
    onNewRelationSelected: (contact: Contact, relation: string) => void
}
interface State {
    relation: string
}

class SearchContactDialog extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);

        this.state = {
            relation: "Client"
        }
    }

    onContactSelect = (contact: Contact) => {
        const { relation } = this.state;
        this.props.onNewRelationSelected(contact, relation)
        this.props.onClose()
    }

    render() {

        return (
            <Dialog open={this.props.open} onClose={this.props.onClose} fullWidth>
                <div style={{ padding: 10 }}>
                    <Typography variant="h5" align="center" style={{ padding: 10 }}>Add Existing Contact</Typography>
                    <Grid container direction="column" alignContent="center">
                        <Grid item>
                            <FormControl style={{ minWidth: 400 }}>
                                <InputLabel htmlFor="Relation">Relation to File</InputLabel>
                                <Select
                                    value={this.state.relation}
                                    onChange={e => this.setState({ relation: e.target.value })}
                                    inputProps={{
                                        id: 'relation',
                                    }}
                                >
                                    <MenuItem value="Client">
                                        Client
                                    </MenuItem>
                                    <MenuItem value="Adversary">
                                        Adversary
                                    </MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                    </Grid>
                    <br />
                    <ContactSearch onContactSelect={this.onContactSelect} />
                </div>
            </Dialog>
        );
    }
}

export default withRoot(withStyles(styles)(SearchContactDialog));